import { useShopFlow } from "@/constants/ShopFlow";
import type { ChildrenType } from "@/types/types";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { useContext } from "react";
import { NotifContext } from "@/contexts/notif-context";
import Alert from "@/components/Alert";
import { useLocation } from "react-router-dom";

export default function Layout({ children }: ChildrenType) {
    const { notif, setNotif } = useContext(NotifContext);
    const isShopFlow = useShopFlow();
    const location = useLocation();
    const isFarmDetail = location.pathname.match(/\/farm\/[^/]+$/);

    let paddingClass = "pt-24 md:pt-32.5";
    if (isShopFlow) {
        paddingClass = "pt-0 md:pt-32.5";
    } else if (isFarmDetail) {
        paddingClass = "pt-16 md:pt-32.5";
    }

    return (
        <>
            {notif && (
                <Alert
                    type={notif.type}
                    title={notif.title}
                    message={notif.message}
                    onDismiss={() => setNotif(null)}
                />
            )}
            <div className="min-h-screen flex flex-col font-sans bg-cream dark:bg-dark text-dark dark:text-cream transition-colors duration-300">
                <Navbar />
                <main className={`grow min-h-screen ${paddingClass}`}>
                    {children}
                </main>
                <Footer />
            </div>
        </>
    );
}
